import { OnboardingFunnelStatus } from 'src/components/enterprise/features/HomePage/types/OnboardingFunnel';

export const BURGER_AND_FRIES_IMAGE_URL =
  'https://res.cloudinary.com/grubhub-assets/image/upload/v1638558942/corps-admin-ui/burger-and-fries.svg';

export interface OnboardingFunnelBannerCopy {
  headerText: string;
  bodyText: string;
  buttonText: string;
}

const BANNER_COPY_BY_STATUS: Record<string, OnboardingFunnelBannerCopy> = {
  [OnboardingFunnelStatus.NOT_STARTED]: {
    headerText: "Let's get started",
    bodyText:
      'Set up your account in a few steps so you can create a meal credit and start feeding people.',
    buttonText: 'Get started',
  },
  [OnboardingFunnelStatus.IN_PROGRESS]: {
    headerText: "Let's finish what you started",
    bodyText:
      'Complete your account so you can create a meal credit and start feeding people.',
    buttonText: 'Finish setup',
  },
};

export function getOnboardingFunnelBannerCopy(
  funnelStatus: OnboardingFunnelStatus
): OnboardingFunnelBannerCopy {
  return (
    BANNER_COPY_BY_STATUS[funnelStatus] ??
    BANNER_COPY_BY_STATUS[OnboardingFunnelStatus.IN_PROGRESS]
  );
}
